import { CheckCircle2, ListTree } from "lucide-react";
import type { SimulatorAppSurfaceProps } from "../AppSurface.js";

export function GenericApp({ activeMachine, app, onRunCommand, profile }: SimulatorAppSurfaceProps) {
  const rows = app.keywords.slice(0, 5).map((keyword, index) => ({
    name: keyword,
    status: index % 2 === 0 ? "Ready" : "Available"
  }));

  return (
    <div className="fd-sim-app fd-sim-generic">
      <header className="fd-generic-head">
        <div>
          <p>{profile.productLabel} - {activeMachine}</p>
          <h2>{app.title}</h2>
        </div>
        <button
          type="button"
          onClick={() => {
            void onRunCommand({
              appId: app.id,
              commandType: "RECORD_APP_CHECK",
              capability: app.launchCapability ?? "simulator.check",
              label: app.title,
              payload: { appId: app.id, machineId: activeMachine, title: app.title }
            });
          }}
        >
          <CheckCircle2 size={16} />
          Inspect
        </button>
      </header>
      <div className="fd-generic-layout">
        <aside>
          <button className="is-active" type="button"><ListTree size={15} /> Overview</button>
          <button type="button">Objects</button>
          <button type="button">Actions</button>
          <button type="button">History</button>
        </aside>
        <section>
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.name}>
                  <td>{row.name}</td>
                  <td>{row.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      </div>
    </div>
  );
}
